import React from 'react'
import Navbar from '../LandingPage/Navbar'
import { Footer } from '../LandingPage/Footer'

function Policy() {
	const baseStyle = 'max-w-4xl mx-auto p-5 text-gray-700 bg-white'

	return (
		<div data-theme="light" className="min-h-screen bg-white pt-28">
			<Navbar minimal />
			<div className={baseStyle}>
			<div className="max-w-4xl mx-auto p-5">
				<div className="container">
					<div
						className="tab-content translations-content-item en visible"
						id="en"
					>
						<h2 className="text-3xl font-bold text-gray-900 mb-4">
							Privacy Policy for LoadFetcher
						</h2>

						<p className="text-md mb-2 text-gray-600">
							Last updated: October 30, 2026
						</p>

						<section className="mb-6">
							<p className="text-gray-700 mb-3">
								This Privacy Policy describes Our policies and procedures on the
								collection, use and disclosure of Your information when You use
								the Service and tells You about Your privacy rights and how the
								law protects You.
							</p>
							<p className="text-gray-700 mb-3">
								We use Your Personal Data to provide and improve the Service. By
								using the Service, You agree to the collection and use of
								information in accordance with this Privacy Policy.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Controller and Contact Information
							</h2>
							<p className="text-gray-700 mb-3">
								Fierce Trade LLC is the "controller" of Personal Data described
								in this Privacy Policy. For privacy-related inquiries, contact
								us at:
							</p>
							<ul className="text-gray-700 mb-3">
								<li>
									<strong>Email:</strong> info@loadfetcher.com
								</li>
								<li>
									<strong>Postal Address:</strong> 30 N Gould St. Ste R,
									Sheridan, WY 82801
								</li>
							</ul>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Interpretation and Definitions
							</h2>
							<h3 className="text-lg font-semibold text-gray-800 mb-3">
								Interpretation
							</h3>
							<p className="text-gray-700 mb-3">
								The words of which the initial letter is capitalized have
								meanings defined under the following conditions. The following
								definitions shall have the same meaning regardless of whether
								they appear in singular or in plural.
							</p>

							<h3 className="text-lg font-semibold text-gray-800 mb-3 mt-4">
								Definitions
							</h3>
							<p className="text-gray-700 mb-3">
								For the purposes of this Privacy Policy:
							</p>

							<ul>
								<li>
									<p className="text-gray-700 mb-3">
										<strong>Account</strong> means a unique account created for
										You to access our Service or parts of our Service.
									</p>
								</li>
								<li>
									<p className="text-gray-700 mb-3">
										<strong>Company</strong> (referred to as either "the
										Company", "We", "Us" or "Our" in this Policy) refers to
										Fierce Trade LLC, 30 N Gould St. Ste R Sheridan, WY 82801.
									</p>
								</li>
								<li>
									<p className="text-gray-700 mb-3">
										<strong>Cookies</strong> are small files that are placed on
										Your computer, mobile device or any other device by a
										website, containing details of Your browsing history on that
										website among its many uses.
									</p>
								</li>
								<li>
									<p className="text-gray-700 mb-3">
										<strong>Country</strong> refers to the United States.
										Governing law for privacy disclosures aligns with our Terms
										of Service (State of Wyoming).
									</p>
								</li>
								<li>
									<p className="text-gray-700 mb-3">
										<strong>Device</strong> means any device that can access the
										Service such as a computer, mobile device, or digital
										tablet.
									</p>
								</li>
								<li>
									<p className="text-gray-700 mb-3">
										<strong>Personal Data</strong> is any information that
										relates to an identified or identifiable individual.
									</p>
								</li>
								<li>
									<p className="text-gray-700 mb-3">
										<strong>Service</strong> refers to LoadFetcher, including
										the website, browser extension(s), mobile applications, APIs, and any
										integrations (e.g., Telegram), accessible
										via https://loadfetcher.com and related subdomains.
									</p>
								</li>
								<li>
									<p className="text-gray-700 mb-3">
										<strong>Service Provider</strong> means any natural or legal
										person who processes the data on behalf of the Company. It
										refers to third-party companies or individuals employed by
										the Company to facilitate the Service, to provide the
										Service on behalf of the Company, to perform services
										related to the Service or to assist the Company in analyzing
										how the Service is used.
									</p>
								</li>
								<li>
									<p className="text-gray-700 mb-3">
										<strong>Usage Data</strong> refers to data collected
										automatically, either generated by the use of the Service or
										from the Service infrastructure itself (for example, the
										duration of a page visit, telemetry, logs, and identifiers).
									</p>
								</li>
								<li>
									<p className="text-gray-700 mb-3">
										<strong>You</strong> means the individual accessing or using
										the Service, or the company, or other legal entity on behalf
										of which such individual is accessing or using the Service,
										as applicable.
									</p>
								</li>
							</ul>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Sources of Data
							</h2>
							<p className="text-gray-700 mb-3">
								We obtain Personal Data from the following sources:
							</p>
							<ul className="text-gray-700 mb-3">
								<li>
									(i) Directly from you (account creation, support requests,
									payment information)
								</li>
								<li>
									(ii) Automatically from your devices and our Services
									(telemetry, logs, device identifiers)
								</li>
								<li>
									(iii) From connected services you authorize (e.g., Telegram,
									or an email account you connect — see Connected Email
									Accounts and Google User Data below)
								</li>
								<li>
									(iv) From publicly available load boards or third-party
									platforms where permitted
								</li>
							</ul>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Browser Extension Data Collection
							</h2>
							<p className="text-gray-700 mb-3">
								<strong>Important:</strong> Our browser extension reads only the
								minimum content required to operate stated features on supported
								freight load board websites as described in the extension's
								details and permissions. It does not collect your browsing
								history outside of supported sites.
							</p>
							<p className="text-gray-700 mb-3">
								The extension operates on websites specified in its manifest
								permissions, which are disclosed when you install the extension.
								You can disable the extension or revoke site access at any time
								through your browser's extension settings.
							</p>
							<p className="text-gray-700 mb-3">
								The extension itself does not perform behavioral or usage
								analytics, advertising or cross-site tracking, or keystroke
								logging. Any analytics described elsewhere in this Policy relates
								to the loadfetcher.com website.
							</p>

							<h3 className="text-lg font-semibold text-gray-800 mb-3 mt-4">
								Load and Trip Data
							</h3>
							<p className="text-gray-700 mb-3">
								To provide its core features on supported freight load boards
								(such as Amazon Relay), the extension reads and processes
								operational freight data from the load board and from your
								carrier account, and sends the relevant portions to our servers
								to power analytics, refresh, mapping, and notification features.
								This may include:
							</p>
							<ul className="text-gray-700 mb-3">
								<li>
									<strong>Load and shipment details:</strong> load identifiers,
									rates and price-per-mile, distance, equipment and trailer type,
									stop counts, and loading type
								</li>
								<li>
									<strong>Route locations:</strong> pickup and delivery cities,
									states, facility codes, and geographic coordinates of the loads
									(these describe the freight and its route, not your personal
									device location)
								</li>
								<li>
									<strong>Schedule information:</strong> pickup and delivery dates
									and times, arrival windows, and estimated times of arrival (ETA)
								</li>
								<li>
									<strong>Trip and driver information</strong> (for trips you are
									executing): trip/tour identifiers, assigned driver names,
									check-in and check-out status, and driver position used to
									compute ETA and trip-status notifications
								</li>
								<li>
									<strong>Carrier information:</strong> your company name and,
									where applicable, carrier identifiers used to associate this
									data with your account
								</li>
							</ul>
							<p className="text-gray-700 mb-3">
								This data is used only to provide the features you request within
								the extension. Trip and driver details are transmitted for
								notifications only when you have enabled and configured them (for
								example, by connecting a Telegram group).
							</p>
							<p className="text-gray-700 mb-3">
								<strong>This collection is optional.</strong> You can turn it off at
								any time using the Local Mode setting described below, which stops
								this data from being sent to us while the extension keeps working
								locally in your browser. You can also disable any individual feature,
								or the extension entirely, at any time.
							</p>
								<p className="text-gray-700 mb-3">
									For the load, trip, and driver data you submit or access
									through the extension, you (the carrier) are the controller of
									that data and LoadFetcher acts as a processor / service
									provider — we process it only on your behalf and to provide
									the features you request.
								</p>

							<h3 className="text-lg font-semibold text-gray-800 mb-3 mt-4">
								Local Mode: Opting Out of Data Collection
							</h3>
							<p className="text-gray-700 mb-3">
								The extension includes an opt-in setting called{' '}
								<strong>Local Mode</strong> (available in Settings and in the
								Refresher settings panel). Local Mode is off by default. When you
								turn it on, the extension stops sending the load, trip, driver,
								and carrier data described above to our servers, along with
								related features such as load analytics, facility ratings and
								reviews, route maps and location search, notifications
								(including Telegram alerts), the shared notification sound
								library, and device management — these features are disabled
								while Local Mode is on because they depend on that data
								reaching our servers.
							</p>
							<p className="text-gray-700 mb-3">
								While Local Mode is on, the extension still contacts our servers
								for three purposes tied to your account: signing you in, confirming your subscription, and ending
								your session when you log out. These requests identify you by
								your account credentials only; your company name is not sent and
								is instead reported to us as "REDACTED." Because Local Mode also
								stops the extension from refreshing your session automatically,
								you may need to sign in again more often while it is on.
							</p>
							<p className="text-gray-700 mb-3">
								You can turn Local Mode on or off at any time from within the
								extension. Features not listed above, such as Refresher, Quick
								Book, and Post Truck, continue to operate locally in your browser
								while Local Mode is on.
							</p>
						</section>

						<section className="mb-6" id="connected-email-accounts">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Connected Email Accounts and Google User Data
							</h2>
							<p className="text-gray-700 mb-3">
								You can connect your own email account to LoadFetcher so that
								You can email freight brokers about loads from the LoadFetcher
								extension (for example, from the DAT One load board). You may
								connect a Google (Gmail) account, a Microsoft (Outlook) account
								or another mailbox through SMTP. Connecting an email account is
								optional.
							</p>
							<h3 className="text-lg font-semibold text-gray-800 mb-3 mt-4">
								What we access
							</h3>
							<ul className="text-gray-700 mb-3">
								<li>
									<strong>Google:</strong> permission to send email on Your
									behalf (the Gmail API scope gmail.send) and Your Google
									account email address (userinfo.email). If You also choose
									"Read and organize emails" when connecting, we additionally
									request permission to read and label the messages in Your
									mailbox (gmail.modify), used only as described below. This
									option is off unless You turn it on, and You can connect
									without it.
								</li>
								<li>
									<strong>Microsoft:</strong> permission to send email on Your
									behalf (Mail.Send), Your basic profile (User.Read) and
									continued access while connected (offline_access).
								</li>
								<li>
									<strong>SMTP:</strong> the server, port, username and
									password You enter, used only to send Your emails.
								</li>
							</ul>
							<h3 className="text-lg font-semibold text-gray-800 mb-3 mt-4">
								How we use it
							</h3>
							<p className="text-gray-700 mb-3">
								We use this access only to send the emails You write or
								explicitly trigger in LoadFetcher (such as an inquiry about a
								load and Your follow-ups to it), from the account You choose,
								and to show which account is connected. We do not send email
								without an action by You or a sending rule You set up.
							</p>
							<p className="text-gray-700 mb-3">
								If You turned on read access for a Gmail account, we also use it
								to show You broker replies to the emails You sent from
								LoadFetcher:
							</p>
							<ul className="text-gray-700 mb-3">
								<li>
									We create a Gmail label named "LoadFetcher" in Your mailbox
									and add it to the emails You send through LoadFetcher, so
									You can find them in Gmail.
								</li>
								<li>
									We ask Google to notify us when new messages arrive in Your
									inbox or under that label. For each new message we look only
									at its identifiers and labels (not its content) to tell
									whether it belongs to a conversation that started with an
									email You sent through LoadFetcher.
								</li>
								<li>
									Only messages in those conversations are opened. We read
									their sender, recipients, subject, date, text and the names
									and sizes of their attachments, save them with the email
									they reply to, and show You a notification and the reply in
									LoadFetcher. Attachments are downloaded from Gmail only when
									You open them, and are not stored by us.
								</li>
								<li>
									We do not open, read, scan or index any other messages in
									Your mailbox, and we do not delete, archive or change
									messages, other than adding the "LoadFetcher" label.
								</li>
							</ul>
							<h3 className="text-lg font-semibold text-gray-800 mb-3 mt-4">
								How we store and protect it
							</h3>
							<ul className="text-gray-700 mb-3">
								<li>
									Access tokens, refresh tokens and SMTP passwords are stored
									encrypted (AES-256) and are used only by our servers to send
									Your emails.
								</li>
								<li>
									For each email You send through LoadFetcher we keep the
									sending account, recipients, subject, message and the load
									it was about, so You can see Your sent history and follow
									up. These records are deleted automatically after 30 days.
								</li>
								<li>
									Replies we receive through read access are stored with the
									email they reply to. The reply text is stored encrypted
									(AES-256) and is deleted automatically together with that
									email, 30 days after it was sent.
								</li>
							</ul>
							<h3 className="text-lg font-semibold text-gray-800 mb-3 mt-4">
								Sharing and limits
							</h3>
							<ul className="text-gray-700 mb-3">
								<li>
									We do not sell Google user data or use it for advertising.
								</li>
								<li>
									We do not transfer it to others except as needed to send
									Your emails and show You their replies (to Google or
									Microsoft, and to our hosting providers acting on our
									behalf), to comply with law, or as part of a merger or
									acquisition with notice to You.
								</li>
								<li>
									Our staff do not read it unless You ask us to (for example,
									in a support request), it is needed for security or abuse
									investigations, or the law requires it.
								</li>
								<li>
									We do not use Google user data to develop, improve or train
									generalized artificial intelligence or machine learning
									models.
								</li>
							</ul>
							<p className="text-gray-700 mb-3">
								LoadFetcher's use and transfer to any other app of information
								received from Google APIs will adhere to the{' '}
								<a
									href="https://developers.google.com/terms/api-services-user-data-policy"
									className="text-blue-600 underline"
									target="_blank"
									rel="noopener noreferrer"
								>
									Google API Services User Data Policy
								</a>
								, including the Limited Use requirements.
							</p>
							<h3 className="text-lg font-semibold text-gray-800 mb-3 mt-4">
								Disconnecting and deletion
							</h3>
							<p className="text-gray-700 mb-3">
								You can disconnect an email account at any time in LoadFetcher
								under Settings → Email → Remove. For Google accounts this also
								revokes LoadFetcher's access with Google. You can also remove
								access from Your Google account at{' '}
								<a
									href="https://myaccount.google.com/permissions"
									className="text-blue-600 underline"
									target="_blank"
									rel="noopener noreferrer"
								>
									myaccount.google.com/permissions
								</a>
								. When You disconnect an account we delete its stored tokens or
								password and stop receiving its replies; You may ask us to
								delete Your sent email records and their replies sooner by
								contacting us. The "LoadFetcher" label stays in Your Gmail until
								You remove it.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Categories of Personal Data Collected
							</h2>
							<p className="text-gray-700 mb-3">
								In the last 12 months, we have collected the following
								categories of Personal Data:
							</p>
							<ul className="text-gray-700 mb-3">
								<li>
									<strong>Identifiers:</strong> name, email address, device ID,
									IP address, account credentials
								</li>
								<li>
									<strong>Commercial Information:</strong> subscription plan,
									payment information, invoices
								</li>
								<li>
									<strong>Internet Activity:</strong> logs, telemetry, usage
									patterns, pages visited, features used
								</li>
								<li>
									<strong>Geolocation:</strong> coarse IP-based location. In our mobile app, precise device
									location is collected only when you choose &quot;Use my
									location&quot; to search, and is used to run that search
								</li>
								<li>
									<strong>Communication Content:</strong> support messages,
									in-product messages, integration content (only if you connect
									Telegram)
								</li>
							</ul>
							<p className="text-gray-700 mb-3">
								<strong>Sensitive Data:</strong> We do not intentionally collect
								sensitive personal data. If provided incidentally (e.g., precise
								location in an attachment), we limit use to the specific service
								you requested.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Cookies, Tracking Technologies, and Opt-Out Signals
							</h2>
							<p className="text-gray-700 mb-3">
								We use Cookies and similar tracking technologies to track
								activity on Our Service and store certain information. We use:
							</p>
							<ul className="text-gray-700 mb-3">
								<li>
									<strong>Strictly Necessary Cookies:</strong> Required for
									authentication, security, and fraud prevention
								</li>
								<li>
									<strong>Functional Cookies:</strong> Remember your preferences
									and settings
								</li>
								<li>
									<strong>Analytics Cookies:</strong> Help us understand
									aggregated usage patterns (with consent where required)
								</li>
							</ul>
							<p className="text-gray-700 mb-3">
								<strong>Opt-Out Signals:</strong> We do not sell or share Personal
								Data and do not serve targeted advertising, so opt-out preference
								signals such as{' '}
								<strong>Global Privacy Control (GPC)</strong> and{' '}
								<strong>Colorado's Universal Opt-Out Mechanism (UOOM)</strong> do
								not currently change how we process your data. If our practices
								change, we will implement and honor these signals as required by
								law.
							</p>
							<p className="text-gray-700 mb-3">
								You can control cookies through your browser settings. Note that
								disabling necessary cookies may affect your ability to use
								certain features of the Service.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Selling, Sharing, and Targeted Advertising
							</h2>
							<p className="text-gray-700 mb-3">
								<strong>We do not sell Personal Data.</strong> We do not "share"
								Personal Data for cross-context behavioral advertising as
								defined under California and other state privacy laws.
							</p>
							<p className="text-gray-700 mb-3">
								If our practices change in the future and we begin selling or
								sharing Personal Data, we will:
							</p>
							<ul className="text-gray-700 mb-3">
								<li>
									Provide a prominent "Do Not Sell or Share My Personal
									Information" link
								</li>
								<li>Automatically honor browser opt-out signals (GPC, UOOM)</li>
								<li>Update this Privacy Policy and provide notice</li>
							</ul>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Purposes for Using Personal Data
							</h2>
							<p className="text-gray-700 mb-3">
								We use Personal Data for the following purposes:
							</p>
							<ul className="text-gray-700 mb-3">
								<li>To provide and maintain the Service</li>
								<li>To manage Your Account and registration</li>
								<li>To process payments and billing</li>
								<li>To provide customer support</li>
								<li>To secure the Service and prevent fraud</li>
								<li>To debug and improve Service functionality</li>
								<li>To conduct analytics and understand usage patterns</li>
								<li>
									To comply with legal obligations (tax, compliance, lawful
									requests)
								</li>
								<li>
									To send optional marketing communications (with consent where
									required)
								</li>
							</ul>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Legal Bases for Processing (EU/UK/Switzerland)
							</h2>
							<p className="text-gray-700 mb-3">
								If you are located in the European Union, United Kingdom, or
								Switzerland, we process your Personal Data based on the
								following legal grounds:
							</p>
							<ul className="text-gray-700 mb-3">
								<li>
									<strong>Performance of Contract:</strong> To provide your
									account and Service features
								</li>
								<li>
									<strong>Legitimate Interests:</strong> For security, fraud
									prevention, analytics, and service improvements (with
									appropriate safeguards)
								</li>
								<li>
									<strong>Consent:</strong> For marketing communications and
									non-essential cookies (where required)
								</li>
								<li>
									<strong>Legal Obligation:</strong> For tax compliance, lawful
									requests, and regulatory requirements
								</li>
							</ul>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Data Retention
							</h2>
							<p className="text-gray-700 mb-3">
								We retain Personal Data only as long as necessary for the
								purposes described in this Privacy Policy. Typical retention
								periods by category:
							</p>
							<ul className="text-gray-700 mb-3">
								<li>
									<strong>Account identifiers & billing records:</strong> Life
									of account + 3 years (for legal and tax purposes)
								</li>
								<li>
									<strong>Logs & telemetry:</strong> 12-24 months
								</li>
								<li>
									<strong>Load & trip data (extension features):</strong>{' '}
									Retained only as long as needed to provide the features you
									use and to identify notifications already sent — no more than
									14 days — after which it is deleted
								</li>
								<li>
									<strong>Emails sent from a connected email account, and
									replies received through read access:</strong>{' '}
									30 days, then deleted automatically
								</li>
								<li>
									<strong>Connected email account credentials (tokens or SMTP
									password):</strong> until You disconnect the account or delete
									Your LoadFetcher account
								</li>
								<li>
									<strong>Support tickets:</strong> 24 months
								</li>
								<li>
									<strong>Payment transaction records:</strong> 7 years (legal
									requirement)
								</li>
							</ul>
							<p className="text-gray-700 mb-3">
								After these periods, we securely delete or anonymize Personal
								Data unless we are required to retain it longer by law.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Sharing Your Personal Data
							</h2>
							<p className="text-gray-700 mb-3">
								We may share Your personal information in the following
								situations:
							</p>
							<ul className="text-gray-700 mb-3">
								<li>
									<strong>With Service Providers:</strong> We use vetted vendors
									to host and process data (e.g., cloud infrastructure, payment
									processing, email delivery, analytics, error monitoring). We
									require data protection terms and security controls from all
									vendors.
								</li>
								<li>
									<strong>For business transfers:</strong> In connection with a
									merger, acquisition, or sale of assets, your Personal Data may
									be transferred to the acquiring entity.
								</li>
								<li>
									<strong>With Affiliates:</strong> We may share information
									with Our affiliates, who will honor this Privacy Policy.
								</li>
								<li>
									<strong>For legal compliance:</strong> When required by law,
									court order, or government request.
								</li>
								<li>
									<strong>With Your consent:</strong> We may disclose Your
									personal information for any other purpose with Your consent.
								</li>
							</ul>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Subprocessors and Third-Party Vendors
							</h2>
							<p className="text-gray-700 mb-3">
								We use third-party processors for cloud hosting/CDN, email
								delivery, error monitoring, analytics, payment processing, and
								customer support. We require data protection terms and security
								controls from all vendors. These include:
							</p>
							<ul className="text-gray-700 mb-3">
								<li>
									<strong>Cloud hosting / infrastructure</strong> (including
									DigitalOcean) — to operate our servers and process load and trip
									data
								</li>
								<li>
									<strong>HERE Technologies</strong> — mapping and geocoding
									provider used to convert location coordinates into place names
									and to provide location-search and route/ETA features
								</li>
								<li>
									<strong>Telegram</strong> — to deliver trip and load
									notifications to a group you connect, if you enable that feature
								</li>
								<li>
									<strong>
										Payment processing, email delivery, analytics, and error
										monitoring
									</strong>{' '}
									providers — to bill, communicate with, and maintain the
									reliability of the Service
								</li>
							</ul>
							<p className="text-gray-700 mb-3">
								A current list of subprocessors is maintained upon request to
								info@loadfetcher.com. We publish material changes to our
								subprocessors at least 15 days before they take effect where
								required by contract or law.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								International Data Transfers
							</h2>
							<p className="text-gray-700 mb-3">
								Your information, including Personal Data, may be transferred to
								and processed in countries other than your own. These countries
								may have data protection laws that differ from those in your
								jurisdiction.
							</p>
							<p className="text-gray-700 mb-3">
								Where required by law (e.g., transfers from the EU, UK, or
								Switzerland), we use approved transfer mechanisms such as
								Standard Contractual Clauses (SCCs) and apply appropriate
								technical and organizational safeguards to protect your data.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Security of Your Personal Data
							</h2>
							<p className="text-gray-700 mb-3">
								We use industry-standard security safeguards to protect your
								Personal Data, including:
							</p>
							<ul className="text-gray-700 mb-3">
								<li>
									Encryption in transit (TLS/SSL) and at rest for core data
									stores
								</li>
								<li>Access controls and authentication mechanisms</li>
								<li>Regular security monitoring and logging</li>
								<li>Security training for personnel with data access</li>
							</ul>
							<p className="text-gray-700 mb-3">
								However, no method of transmission over the Internet or
								electronic storage is 100% secure. While we strive to protect
								your Personal Data, we cannot guarantee absolute security.
							</p>
							<p className="text-gray-700 mb-3">
								In the event of a data breach that affects your Personal Data,
								we will notify you and/or regulators as required by applicable
								law, including state breach notification laws and GDPR
								requirements.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Your Privacy Rights and Opt-Outs
							</h2>
							<p className="text-gray-700 mb-3">
								Depending on where you live, you may have the following rights
								regarding your Personal Data:
							</p>
							<ul className="text-gray-700 mb-3">
								<li>
									<strong>Access/Right to Know:</strong> Request access to the
									Personal Data we have about you
								</li>
								<li>
									<strong>Correction:</strong> Request correction of inaccurate
									Personal Data
								</li>
								<li>
									<strong>Deletion:</strong> Request deletion of your Personal
									Data (subject to legal retention requirements)
								</li>
								<li>
									<strong>Portability:</strong> Receive a copy of your Personal
									Data in a portable format
								</li>
								<li>
									<strong>Opt-Out of Sale/Sharing:</strong> Opt out of any sale
									or sharing of Personal Data (though we do not currently sell
									or share)
								</li>
								<li>
									<strong>Opt-Out of Targeted Advertising:</strong> Opt out of
									targeted advertising
								</li>
								<li>
									<strong>Limit Use of Sensitive Data:</strong> Request limits
									on use of sensitive personal information
								</li>
								<li>
									<strong>Non-Discrimination:</strong> Exercise your rights
									without discrimination
								</li>
							</ul>

							<h3 className="text-lg font-semibold text-gray-800 mb-3 mt-4">
								State-Specific Privacy Rights
							</h3>
							<p className="text-gray-700 mb-3">
								As of August 24, 2026, residents of the following U.S. states
								have specific privacy rights under state law:
							</p>
							<p className="text-gray-700 mb-3">
								<strong>
									California (CCPA/CPRA), Colorado (CPA), Connecticut (CTDPA),
									Delaware (DPDPA), Iowa (ICDPA), Montana (MCDPA), New Jersey
									(NJDPA), New Hampshire (NHDPL), Oregon (OCPA), Texas (TDPSA),
									Utah (UCPA), Virginia (VCDPA)
								</strong>
							</p>

							<h3 className="text-lg font-semibold text-gray-800 mb-3 mt-4">
								Opt-Out Preference Signals
							</h3>
							<p className="text-gray-700 mb-3">
								We do not sell or share Personal Data or serve targeted
								advertising, so the following browser-based opt-out signals do not
								currently change how we process your data:
							</p>
							<ul className="text-gray-700 mb-3">
								<li>
									<strong>Global Privacy Control (GPC)</strong> - California and
									other states
								</li>
								<li>
									<strong>Universal Opt-Out Mechanism (UOOM)</strong> - Colorado
									and other states
								</li>
							</ul>
							<p className="text-gray-700 mb-3">
								If our practices change and we begin selling or sharing Personal
								Data or serving targeted advertising, we will implement and honor
								these signals as required by law.
							</p>

							<h3 className="text-lg font-semibold text-gray-800 mb-3 mt-4">
								How to Exercise Your Rights
							</h3>
							<p className="text-gray-700 mb-3">
								To exercise your privacy rights, please submit a request to:
								<strong> info@loadfetcher.com</strong>
							</p>
							<p className="text-gray-700 mb-3">
								We will verify your identity before processing your request. We
								will respond within the timeframe required by applicable law
								(typically 30-45 days).
							</p>

							<h3 className="text-lg font-semibold text-gray-800 mb-3 mt-4">
								Right to Appeal
							</h3>
							<p className="text-gray-700 mb-3">
								If we deny your privacy request, you have the right to appeal.
								You can appeal by replying to our decision email; instructions
								will be included in our response.
							</p>
							<p className="text-gray-700 mb-3">
								If your appeal is unresolved, you may contact your state
								Attorney General to file a complaint.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Children's Privacy
							</h2>
							<p className="text-gray-700 mb-3">
								Our Service is not directed to children under the age of 13. We
								do not knowingly collect personally identifiable information
								from anyone under the age of 13.
							</p>
							<p className="text-gray-700 mb-3">
								We also do not knowingly "sell" or "share" Personal Data of
								consumers under 16 years of age without affirmative
								authorization.
							</p>
							<p className="text-gray-700 mb-3">
								If You are a parent or guardian and You are aware that Your
								child has provided Us with Personal Data, please contact Us at
								info@loadfetcher.com. If We become aware that We have collected
								Personal Data from anyone under the age of 13 without
								verification of parental consent, We take steps to remove that
								information from Our servers.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Links to Other Websites and Third-Party Platforms
							</h2>
							<p className="text-gray-700 mb-3">
								Our Service may contain links to other websites that are not
								operated by Us. If You click on a third party link, You will be
								directed to that third party's site.
							</p>
							<p className="text-gray-700 mb-3">
								We strongly advise You to review the Privacy Policy of every
								site You visit. Interactions with third-party platforms (e.g.,
								freight load boards, Telegram) are governed by
								their own privacy policies. Their independent data practices are
								not controlled by us.
							</p>
							<p className="text-gray-700 mb-3">
								We have no control over and assume no responsibility for the
								content, privacy policies or practices of any third party sites
								or services.
							</p>
						</section>

						<section className="mb-6">
							<h2 className="text-2xl font-bold text-gray-800 mb-3">
								Changes to this Privacy Policy
							</h2>
							<p className="text-gray-700 mb-3">
								We may update Our Privacy Policy from time to time. We will
								notify You of any changes by:
							</p>
							<ul className="text-gray-700 mb-3">
								<li>Posting the new Privacy Policy on this page</li>
								<li>Updating the "Last updated" date at the top</li>
								<li>
									Displaying a prominent notice on Our Service (for material
									changes)
								</li>
							</ul>
							<p className="text-gray-700 mb-3">
								For material changes (e.g., starting to sell or share data, new
								purposes for processing), we will provide prominent notice and,
								where required by law, obtain consent or renewed acknowledgment.
							</p>
							<p className="text-gray-700 mb-3">
								You are advised to review this Privacy Policy periodically for
								any changes. Changes to this Privacy Policy are effective when
								they are posted on this page.
							</p>
						</section>

						<h2 className="text-3xl font-bold text-gray-700 mb-3 text-xl">
							User Responsibilities
						</h2>
						<p className="text-gray-700 mb-3">
							By using LoadFetcher's services, You acknowledge and agree that it
							is solely Your responsibility to ensure that Your use of the
							Service, including any data fetching or interaction with
							third-party websites, complies with the terms of service, usage
							policies, robots.txt files, and any other applicable rules or
							restrictions of those third-party websites.
						</p>
						<p className="text-gray-700 mb-3">
							You are responsible for conducting Your own research and due
							diligence to determine whether Your intended use of the Service
							complies with all applicable laws, regulations, and third-party
							terms and conditions. LoadFetcher does not provide legal advice
							and makes no representations or warranties regarding the legality
							of Your use of the Service in relation to any specific website or
							jurisdiction.
						</p>
						<p className="text-gray-700 mb-3">
							You agree to indemnify and hold harmless LoadFetcher, its
							affiliates, officers, directors, employees, and agents from any
							claims, damages, losses, or expenses (including reasonable
							attorney's fees) arising from Your violation of any third-party
							website's terms of service or applicable laws through Your use of
							the Service.
						</p>

						<h2 className="text-3xl font-bold text-gray-700 mb-3 text-xl">
							Contact Us
						</h2>
						<p className="text-gray-700 mb-3">
							If you have any questions about this Privacy Policy or wish to
							exercise your privacy rights, You can contact us:
						</p>
						<ul className="text-gray-700 mb-3">
							<li>
								<p>
									<strong>Email:</strong> info@loadfetcher.com
								</p>
							</li>
							<li>
								<p>
									<strong>Postal Address:</strong> Fierce Trade LLC, 30 N Gould
									St. Ste R, Sheridan, WY 82801
								</p>
							</li>
							<li>
								<p>
									<strong>Website:</strong>{' '}
									<a
										href="https://loadfetcher.com/policy"
										rel="external nofollow noopener"
										target="_blank"
									>
										https://loadfetcher.com/policy
									</a>
								</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<Footer />
		</div>
	)
}

export default Policy
